(function () {
  'use strict';

  /* @ngdoc object
   * @name account.preferences
   * @description
   *
   */
  angular
    .module('account.preferences', [
      'ui.router'
    ]);
}());
